import React from 'react';

export const Loader = ({ color }: { color?: string }) => {
	return (
		<div className="flex  relative">
			<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
				<div
					className={`border-4 border-solid border-opacity-10 ${
						color ? `border-[${color}]` : 'border-blue-500'
					} border-left-4 rounded-full w-10 h-10 spinner`}
				></div>
			</div>
		</div>
	);
};
